import React, { FC } from 'react';

import { useSceneEditing } from '../../hooks';
import { ShapeElement } from '../../model/types';
import { ColorField, PanelSection, SliderField } from '../common';

interface ShapePropertiesProps {
  element: ShapeElement;
}

export const ShapeProperties: FC<ShapePropertiesProps> = ({ element }) => {
  const { patchElement } = useSceneEditing();

  return (
    <PanelSection title="Kształt">
      <ColorField
        label="Wypełnienie"
        value={element.fill}
        allowEmpty
        onChange={(fill) => patchElement(element.id, { fill }, `shape-fill-${element.id}`)}
      />
      <ColorField
        label="Obrys"
        value={element.stroke}
        allowEmpty
        onChange={(stroke) => patchElement(element.id, { stroke }, `shape-stroke-${element.id}`)}
      />
      {Boolean(element.stroke) && (
        <SliderField
          label="Grubość obrysu"
          suffix=" px"
          min={1}
          max={60}
          value={element.strokeWidth || 1}
          onChange={(strokeWidth) => patchElement(element.id, { strokeWidth }, `shape-stroke-width-${element.id}`)}
        />
      )}
      {element.shape === 'rect' && (
        <SliderField
          label="Zaokrąglenie"
          suffix=" px"
          min={0}
          max={Math.round(Math.min(element.width, element.height) / 2)}
          value={element.radius}
          onChange={(radius) => patchElement(element.id, { radius }, `shape-radius-${element.id}`)}
        />
      )}
    </PanelSection>
  );
};
